import { createRouter } from '@tanstack/react-router'
import type { CrumbId } from '../features/shell/breadcrumbs'
import { routeTree } from '../routeTree.gen'
import { queryClient } from './query-client'
import { NotFound, PagePending, RouteError } from './route-states'

export const router = createRouter({
  routeTree,
  context: { queryClient },
  // Data freshness is TanStack Query's job; the router always asks it.
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: RouteError,
  defaultNotFoundComponent: NotFound,
  defaultPendingComponent: PagePending,
  scrollRestoration: true,
  scrollToTopSelectors: ['#main'],
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
  interface StaticDataRouteOption {
    /** This route's entry in the breadcrumb trail. */
    crumb?: CrumbId
    /**
     * Rendered without the sidebar and top bar (the till): the page fills the window and brings its
     * own header. Session and permission guards still apply.
     */
    fullScreen?: boolean
  }
}
